enum Recognition {
  ErrUnknown = "PBRECUnkown",
  ErrInvalidArguments = "PBRECInvalidArguments",
  ErrNotEnoughPeople = "PBRECNotEnoughPeople",
  ErrNotFound = "PBRECNotFound",
  ErrUnauthorized = "PBRECUnauthorized",
  ErrAlreadyExists = "PBRECAlreadyExists",
  ErrDBPing = "PBRECDBPing",
  ErrTeamNotFound = "PBRecognitionAppCreateRecognitionFailedNoGenericTeams",
  ErrMigrating = "PBRecognitionAppUnavailable"
}
export default Recognition
